import './ShoppingTicket.css'
import React, { useState } from "react";
import MahutiModal from "../mahuti-modal/MahutiModal";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedActivity, setSteps } from "../../store/MahutiReducer";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from '../../store/mahutiLocalStorage';
import { PAGES, PREFIX_PATH } from '../../utils/GlobalParams';
import { myStepsActivity, myStepsActivityMOBILE } from '../../utils/stepperUtils';
import { isMobile } from 'react-device-detect';

export default function ShoppingTicket(props) {
    const [videoOpen, setVideoOpen] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const store = useSelector(store => store.reducer);
    // const [getLocalStorage] = useLocalStorage();
    // let steps = isMobile ? myStepsActivityMOBILE : myStepsActivity

    const onClickPayHandle = (e, scrollLine) => {
        
        dispatch(setSelectedActivity(props));
        // dispatch(setSteps(steps))
        let lpPrefix = store.lpName ? `/${store.lpName}` : '';
        const navLink = `${PREFIX_PATH}${lpPrefix}/${PAGES.ACTIVITY_FLOW}/${props.URI_Indentifier__c}#${scrollLine}`;
        navigate(navLink);
    }


    return <div className={"shoppingTicket card text-start p-3 h-100 border-0 "} >
        {props.isEditMode && <i className="icon-success-1" />}
        <div className="card-header py-1 px-0 border-0">
            <h5 className="card-title">{props.Title ? props.Title : '---'}</h5>
            <h6 className="card-subtitle">{props.Subtitle ? props.Subtitle : '--'}</h6>
        </div>

        <div className={`d-flex justify-content-center align-items-center ${props.videoURL && 'pointer'}`} onClick={() => props.videoURL && setVideoOpen(true) }>
            <img className="bd-placeholder-img card-img-top rounded-0 py-1" width="100%"
                src={props.imageURL}
            alt='' />
            {props.videoURL && <div className="small_video_icon position-absolute"></div>}
        </div>
        {videoOpen && <MahutiModal closeModalWhenClickingBg={true} setModalOpen={setVideoOpen}>
            {props.videoURL && <iframe className='video_iframe_ticket' src={props.videoURL} width='100%' height='100%' title="Video popup" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen={true}></iframe>}
        </MahutiModal>}
        <div className="p-0">
            <div className="text-mahuti py-1 mt-1">
                <div className="row">
                    <div className='col-6 d-flex mx-0 my-2 verticalLine'>
                        <div className="card-detail-time d-flex align-items-center">
                            <i className="clock me-2" />
                            <div className="d-flex flex-column">
                                <div className="text-right text fw-bold">
                                    {props.DurationTime ? `${props.DurationTime} דקות` : '--'}
                                </div>
                                {/* <div className="text-right text tiny-text">עם הפסקה קצרה</div> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-6 d-flex align-items-center m-0">
                        <div className="card-detail-price d-flex align-items-center">
                            <i className="shekel me-2"></i>
                            <div className='d-flex flex-column'>
                                {props.price ? <div className="text-right fw-bold">
                                    {props.price.underAge || '--'}  ₪ לילד
                                </div> : '--'}
                                {props.price ? <div className="text-right tiny-text">
                                    (מבוגר {props.price.adults || '--'} ₪)
                                </div> : '--'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p className="description card-text py-1 my-1">{props.shortDescription__c || '--'}</p>
        </div>
        {props.disclaimer && props.disclaimer.length > 0 && <ul className="product_details_list alef card-body card-options py-1">
            {
                props.disclaimer.map((item) => {
                    return <li key={item.Id}>{item.Name}</li>
                })
            }
        </ul>}
        <div className="card-footer border-top-0 p-0">
            <div className="d-flex justify-content-between" >
                <button type="button" onClick={(e) => onClickPayHandle(e, 'sellingflow')} className="almoni_tzar_normal btn card-button btn-primary w-100 rounded-0 border-0">לרכישה</button>
            </div>
            <div className="text-end mt-3">
                <a className="btn-link fw-bold pointer" onClick={(e) => onClickPayHandle(e, 'productDetailsDisplay')} >לפרטים נוספים</a>
            </div>
        </div>
    </div>

}